export const ROSTER_UPLOAD_PATH = '/storymakers/upload-csv';
export const ROSTER_UPLOAD_ORGANIZATION_PARAM = 'organizationId';

export const parseRosterOrganizationIdParam = (value: Maybe<string>): number | null => {
  const parsed = Number(value);

  return value && Number.isInteger(parsed) && parsed > 0 ? parsed : null;
};

export const buildRosterUploadUrl = (organizationId?: number | string | null): string => {
  if (organizationId === undefined || organizationId === null || organizationId === '') {
    return ROSTER_UPLOAD_PATH;
  }
  return `${ROSTER_UPLOAD_PATH}?${ROSTER_UPLOAD_ORGANIZATION_PARAM}=${organizationId}`;
};

export const CUSTOM_FIELD_NAME_MAX_LENGTH = 64;

export const MAPPING_NAME_MAX_LENGTH = 75;

export const REVIEW_EXAMPLE_ROW_COUNT = 3;

export const MAX_LISTED_ROW_ERRORS = 20;

export const LEGACY_HEADERS: readonly string[] = ['FIRST_NAME', 'LAST_NAME', 'EMAIL'];

export const LEGACY_COLUMN_COUNT = LEGACY_HEADERS.length;

export const CSV_MIME_TYPE = 'text/csv';

export const XLSX_MIME_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

const XLSX_MACRO_ENABLED_MIME_TYPE = 'application/vnd.ms-excel.sheet.macroenabled.12';

export const XLSX_MIME_TYPES: readonly string[] = [XLSX_MIME_TYPE, XLSX_MACRO_ENABLED_MIME_TYPE];

export const ADDITIONAL_FEATURES_NONE = 'none';
